import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import axios, { CancelToken } from "axios";
import { useTranslation, Trans } from "react-i18next";

import { StatusCode } from "api/protocols";
// import { GetTeeSheetNotificationAll } from "api/rpc/2024-04/facilityAdmin/teesheet/notification";

import { showError } from "redux/actions/ui";
// import { TTeesheetNotification } from "redux/reducers/models/teesheet";
import { useAppDispatch } from "hooks/redux";

import Page from "components/page/Page";
import DataTable from "components/dataTable/DataTable";
import {
  DeleteReservationNotification,
  GetReservationNotificationAll,
} from "api/rpc/2024-04/facilityAdmin/reservation/reservation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popup from "components/popup/Popup";

export default function ReservationNotifications() {
  const history = useHistory();
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  // const dateAsString = location && location.state.params !== undefined
  //   ? new Date(location.state.params as Date).toISOString().slice(0, 10)
  //   : new Date().toISOString().slice(0, 10);

  const [notifications, setNotifications] = useState(undefined);
  const [filters, setFilters] = useState({
    date: undefined,
  });

  const [filterState, setFilterState] = useState({
    openDeleteConfirmation: false,
    deleteNotificationId: null,
  });

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadReservationNotifications(filters.date, source.token);
    return () => source.cancel();
  }, [filters.date]);

  async function loadReservationNotifications(date: Date, token?: CancelToken) {
    if (notifications !== undefined) {
      setNotifications(undefined);
    }
    const res = await GetReservationNotificationAll(null, token ? false : true, token);
    if (token && token.reason) {
      return;
    }

    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("Error loading teesheet notifications.")));
    }

    setNotifications(res.status !== StatusCode.OK ? [] : res.data);
  }

  const primaryAction = {
    content: t("New Notification"),
    action: () => history.push("/admin/settings/reservations/notifications/new"),
  };

  async function handleDeleteNotification() {
    const deleteNotificationRes = await DeleteReservationNotification({ id: filterState.deleteNotificationId }, true);

    if (deleteNotificationRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error deleting reservation notification")));
    }

    const source = axios.CancelToken.source();
    setFilterState(prevState => ({
      ...prevState,
      openDeleteConfirmation: false,
      deleteNotificationId: null,
    }));
    void loadReservationNotifications(filters.date, source.token);
  }

  return (
    <Page
      title={t("Reservation Notifications")}
      subtitle={t("Create a Reservation Notification")}
      narrow
      primaryAction={primaryAction}
    >
      <DataTable
        columns={[
          { label: t("Start Date") },
          { label: t("End Date") },
          { label: t("Subject") },
          { label: t("Type") },
          { label: "" },
        ]}
        loading={notifications === undefined}
      >
        {notifications?.map((notification: any) => {
          return (
            <tr key={notification.id}>
              <td
                className="clickable"
                onClick={() => history.push(`/admin/settings/reservations/notifications/${String(notification.id)}`)}
              >
                {moment.utc(notification.start_date).format("MMM DD, YYYY")}
              </td>
              <td
                className="clickable"
                onClick={() => history.push(`/admin/settings/reservations/notifications/${String(notification.id)}`)}
              >
                {moment.utc(notification.end_date).format("MMM DD, YYYY")}
              </td>
              <td
                onClick={() => history.push(`/admin/settings/reservations/notifications/${String(notification.id)}`)}
                className="clickable"
              >
                {notification.subject}
              </td>
              <td
                onClick={() => history.push(`/admin/settings/reservations/notifications/${String(notification.id)}`)}
                className="clickable"
              >
                {notification.type}
              </td>
              <td
                onClick={() =>
                  setFilterState(prevState => ({
                    ...prevState,
                    openDeleteConfirmation: true,
                    deleteNotificationId: notification.id,
                  }))
                }
                className="flex justify-center"
              >
                <div className="cursor-pointer customer-profile" style={{ textDecorationLine: "none" }}>
                  {t("Delete")}
                  <FontAwesomeIcon icon={["far", "trash"]} />
                </div>
              </td>
            </tr>
          );
        })}
      </DataTable>

      <Popup
        open={filterState.openDeleteConfirmation}
        type={"warning"}
        title={t("Delete Notification")}
        description={t("Are you sure you want to delete this notification")}
        okText={t("Delete ")}
        cancelText={t("Cancel")}
        backDropCancel
        onOk={() => handleDeleteNotification()}
        onCancel={() => setFilterState(prevState => ({ ...prevState, openDeleteConfirmation: false }))}
      />
    </Page>
  );
}
